<!-- <div class="Spinner-container in-block">
  <div class="Spinner-circle {{height}} {{width}}" style.margin="{{margin}}"></div>
</div> -->

<!--https://codepen.io/smashtheshell/pen/jqGxzr?limit=all&page=2&q=spinner-->
<div class="spinner {{height}} {{width}}"></div> 
